var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"standarts-catalog-standart-pages"}},[_c('PageTitle',{attrs:{"title":_vm.title,"loading":_vm.loading,"icon":""}}),_c('StandartsCatalogModule',{attrs:{"id":_vm.mid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }